// libs
import React, { memo } from 'react';

// analytics
import { onCartClick } from 'shared/components/Header/analytics';

// context
import { useDwebCartContext } from 'shared/components/DwebCart/context';

// styles
import { CartContainer, TextContainer, Icon, CartCount } from './styles';

// constants
const CART_TITLE = 'Cart';

interface ICartProps {
  cartCount: number | string;
}

function Cart({ cartCount }: ICartProps) {
  const { showCart } = useDwebCartContext();

  const goToCart = () => {
    onCartClick();

    showCart();
  };
  return (
    <CartContainer role="button" aria-label="cart" onClick={goToCart}>
      <Icon className="icon-bag" />
      <CartCount>{cartCount}</CartCount>
      <TextContainer>{CART_TITLE}</TextContainer>
    </CartContainer>
  );
}

export default memo(Cart);
